
export default {
  name: 'VsGallery',
  inheritAttrs: false,
  props: {
    items: {
      type: Array,
      default: () => []
    },
    first: {
      type: Number,
      default: null
    },
    offset: {
      type: Number,
      default: 0
    },
    ratio: {
      type: [String, Object],
      default: 'square'
    },
    poster: {
      type: Boolean,
      default: false
    },
    lazy: {
      type: Boolean,
      default: true
    },
    autoFill: {
      type: [String, Object],
      default: '4xl'
    },
    columns: {
      type: [String, Number, Object],
      default: null
    },
    mode: {
      type: String,
      default: 'dark'
    },
    lightbox: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    wrapper: {
      $attrs: 'all'
    }
  },
  data() {
    return {
      visible: false,
      active: null
    }
  },
  computed: {
    visibleItems() {
      const items = [...this.items]
      const limit = this.first || items.length

      return items.splice(this.offset, limit)
    },
    cursor() {
      return this.lightbox ? 'pointer' : null
    }
  },
  methods: {
    show(item) {
      if (this.lightbox) {
        this.active  = item
        this.visible = true
      }
    },
    colSpan(index) {
      return this.poster && index == 0 ? (this.columns || 12) : null
    }
  }
}
